export default function normalizeSymbol(symbol) {
    return symbol.replace(/[^\w]/g, '_');
}



/** WEBPACK FOOTER **
 ** /src/shared/service/normalizesymbol.js
 **/